import React from "react";
import { Navigate } from "react-router-dom";
import { FaEnvelopeOpen } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import "./ProtectedRoute.css";

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <div className="session-splash" role="status" aria-live="polite" aria-busy="true">
        <div className="session-splash-inner">
          <div className="session-brand">
            <span className="session-logo-badge">
              <FaEnvelopeOpen />
            </span>
            <span className="session-logo-text">PhishMatrix AI</span>
          </div>

          <div className="session-spinner" aria-hidden="true">
            <span className="session-spinner-ring" />
            <FaEnvelopeOpen className="session-spinner-glyph" />
          </div>

          <div className="session-status">Checking your session…</div>
          <div className="session-sub">Securely restoring your workspace</div>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
